
import { NgModule, LOCALE_ID, APP_INITIALIZER } from '@angular/core';
import { SharedModule } from './shared/shared.module';
import { HttpModule, RequestOptions, XHRBackend } from '@angular/http';
import { routing } from './app.routes';
import { UrlSerializer } from '@angular/router';
import { LowerCaseUrlSerializer } from "./shared/lower-case-url-serializer ";
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component'
import { PageNotFoundComponent } from './page-not-found.component';
import { MyDatePickerModule } from 'mydatepicker';
import { HttpService } from './shared/http.service';
import { KeepInTouchModule } from './keep-in-touch/keep-in-touch.module';
import { MatanotModule } from "./matanot/matanot.module";
import { PeiluyotModule } from "./peiluyots/peiluyot.module";
import { NofeshModule } from "./nofesh/nofesh.module";
import { NofshonimChulModule } from './nofshonim-chul/nofshonim-chul.module';
import localeFr from '@angular/common/locales/fr';
import { registerLocaleData } from '@angular/common';
import { AdminModule } from './admin/admin.module';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { MatDatepickerModule,MatNativeDateModule,MatFormFieldModule,MatInputModule, MAT_DATE_LOCALE, MatProgressSpinnerModule, MatTooltipModule, MatButtonModule, MatExpansionModule } from '@angular/material';
import { MatSnackBarModule } from "@angular/material/snack-bar";
import {MatDialogModule, MAT_DIALOG_DEFAULT_OPTIONS, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { MatMomentDateModule, MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from "@angular/material-moment-adapter";
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpTokenInterceptor } from './http-token.interceptor';
import { SpinnerComponent } from './shared/spinner/spinner/spinner.component';
import { SpinnerService } from './shared/spinner/spinner.service';
import { MishpachotChulModule } from './mishpachot-chul/mishpachot-chul.module';
import { ConfirmDialogComponent } from './shared/dialog/confirm-dialog/confirm-dialog.component';
import { ConfigService } from './shared/config.service';
import { LoginService } from './login/login.service';

import {MatCheckboxModule} from '@angular/material/checkbox';
import { NofeshPnimModule } from './nofesh-pnim/nofesh-pnim/nofesh-pnim.module';
import { FavoritesNofashimModule } from './favorites-nofashim/favorites-nofashim.module';
import { MainOrderComponent } from './vouchers/main-order/main-order.component';
import { OrderDetailsComponent } from './vouchers/order-details/order-details.component';
import { OrderService } from './vouchers/vouchers/order.service';
import { VouchersModule } from './vouchers/vouchers/vouchers.module';





registerLocaleData(localeFr);

export function HttpServiceFactory(backend: XHRBackend, options: RequestOptions) {
  return new HttpService(backend, options);
}

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent, 
    PageNotFoundComponent,
    SpinnerComponent,
    //ModalComponent,   
    ConfirmDialogComponent

  ],

  exports: [
    MatDatepickerModule,
    MatFormFieldModule,
    MatNativeDateModule,
    MatInputModule,
    BrowserAnimationsModule,
    MatTooltipModule,
    MatButtonModule,
    MatCheckboxModule,
    MatSnackBarModule
  ],

  imports: [
    BrowserModule,
    HttpModule,
    routing,
    MyDatePickerModule,
    KeepInTouchModule,
    MatanotModule,
    PeiluyotModule,
    NofeshModule,
    NofshonimChulModule,
    SharedModule,
    AdminModule,
    HttpClientModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatNativeDateModule,
    MatInputModule,
    BrowserAnimationsModule,
    MatMomentDateModule,
    MatProgressSpinnerModule,
    MatDialogModule,
    MishpachotChulModule,
    NofeshPnimModule,
    FavoritesNofashimModule,
    VouchersModule
  ],
  providers: [    
    LoginService,
    SpinnerService,
    {
      provide: APP_INITIALIZER,
      // In useFactory we need to execute a function from the service, but we cannot do it directly.
      // We need to create a function which invokes the service function and returns a Promise. 
      // We do that in the second arrow function. 
      useFactory: (configService: ConfigService) => (promise: Promise<void | {}>) => { 
        // First we load the mandatory config file.
        // If the file loaded successfully, we will inject Google Analytics key into index.html scripts.
        return configService.loadConfigJSON().then(success => {
          configService.injectGoogleAnalyticsKey();
          return new Promise((resolve) => { resolve(null); });
        }, error => {
          return new Promise((reject) => { reject(null); });
        });
      },
      deps: [ConfigService],
      multi: true
    },
    {
      provide:HTTP_INTERCEPTORS,
      useClass: HttpTokenInterceptor,
      multi: true
    },
    {
      provide:MatDatepickerModule 
    },
    {
      provide: HttpService,
      useFactory: HttpServiceFactory,
      deps: [XHRBackend, RequestOptions]
     },
    // {
    //   provide: HttpClient
     
    // },
    {
      provide: LOCALE_ID,
      useValue: 'en-US'
     },
     {
       provide: UrlSerializer,
       useClass: LowerCaseUrlSerializer
     },
     {
      provide: MAT_DATE_LOCALE, 
      useValue: "he-IL"
    },
    { 
      provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, 
      useValue: { useUtc: true } 
    },
    {
      provide: MAT_DIALOG_DEFAULT_OPTIONS,
      useValue: {}
    },
    {
        provide: MatDialogRef,
        useValue: {}
    },
    {
        provide:MAT_DIALOG_DATA,useValue:{}
    }
],
entryComponents: [ConfirmDialogComponent],   
  bootstrap: [AppComponent]
  
})
export class AppModule { }
